import { useMutation } from '@tanstack/react-query'

import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'
import { downloadCsv } from '@/utils/file'

import { authAPI } from '../new-api'
import { GetUnitsRequest } from './get-units'

export interface ExportUnitsRequest extends Omit<GetUnitsRequest, 'limit' | 'skip'> {
  fileName: string
}

export const exportUnits = async (data: Omit<GetUnitsRequest, 'limit' | 'skip'>) => {
  const response = await authAPI.get<Blob>('/units/export', {
    params: data,
    responseType: 'blob',
  })
  return response.data
}

export const useExportUnits = () => {
  return useMutation({
    mutationFn: async ({ fileName, ...rest }: ExportUnitsRequest) => {
      const blob = await exportUnits(rest)

      return downloadCsv({ blob, filename: fileName })
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })
}
